// removed by extract-text-webpack-plugin
module.exports = {"dialog":"dialog__Ggu1o","opened":"opened__3ZXjO","actions":"actions__1ZNwx","background":"background___ptEa","fadeIn":"fadeIn__2qHzJ"};


//////////////////
// WEBPACK FOOTER
// ./components/dialog/style.scss
// module id = G7Nt
// module chunks = 9